import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 57,
	height: 55,
	viewBox: "0 0 57 55",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20389 20H4C1.79086 20 0 21.7909 0 24V51C0 53.2091 1.79086 55 4 55H43C45.2091 55 47 53.2091 47 51V27.2667C47 25.0575 45.2091 23.2667 43 23.2667H15.6785C14.502 23.2667 13.3852 22.7488 12.6252 21.8508L12.2572 21.4159C11.4971 20.5179 10.3803 20 9.20389 20Z",
			fill: "#D0D3DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.72742 32.5506L3.1185 49.5506C2.09914 52.1727 4.03341 55 6.84667 55H44.1283C45.7548 55 47.2193 54.0151 47.8328 52.5088L54.7564 35.5088C55.8279 32.878 53.8924 30 51.0519 30H13.4556C11.8058 30 10.3252 31.0129 9.72742 32.5506Z",
			fill: "#E4E7EE"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 14,
			r: 4.25,
			stroke: "#D0D3DB",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M40.0203 16.6576L41.2512 12.6548L40.1876 12.3277L38.9567 16.3306L35.1597 15.163L34.8327 16.2266L38.6296 17.3942L37.4621 21.1911L38.5257 21.5181L39.6932 17.7212L43.696 18.9521L44.0231 17.8885L40.0203 16.6576Z",
			fill: "#D0D3DB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.1198 3.27961C35.6425 2.53786 36.8034 2.81975 36.9278 3.71861L37.0612 4.68312C37.0992 4.95755 37.2493 5.20393 37.4757 5.36352L38.2717 5.9244C39.0134 6.4471 38.7315 7.60804 37.8327 7.73239L36.8681 7.86582C36.5937 7.90378 36.3473 8.05389 36.1878 8.28035L35.6269 9.07628C35.1042 9.81803 33.9432 9.53614 33.8189 8.63728L33.6855 7.67277C33.6475 7.39834 33.4974 7.15196 33.2709 6.99237L32.475 6.43149C31.7332 5.90879 32.0151 4.74785 32.914 4.6235L33.8785 4.49007C34.1529 4.45211 34.3993 4.302 34.5589 4.07554L35.1198 3.27961Z",
			fill: "#D0D3DB"
		})
	]
});
export default SvgIcFolder;
